import challengeApi from "../api/challenge-api";

import {
    call,
    put,
    takeLatest,
} from 'redux-saga/effects'

import {
    GET_CHALLENGES,
    GET_CHALLENGES_ERROR,
    GET_CHALLENGES_REQUEST,
    GET_CHALLENGES_SUCCESS,
    GET_USER_CHALLENGES,
    GET_USER_CHALLENGES_ERROR,
    GET_USER_CHALLENGES_REQUEST,
    GET_USER_CHALLENGES_SUCCESS,
    SEND_CHALLENGE_ACTION,
    SEND_CHALLENGE_ACTION_ERROR,
    SEND_CHALLENGE_ACTION_REQUEST,
    SEND_CHALLENGE_ACTION_SUCCESS,
    START_CHALLENGE,
    START_CHALLENGE_ERROR,
    START_CHALLENGE_REQUEST,
    START_CHALLENGE_SUCCESS,
    UPDATE_USER_CHALLENGE,
    UPDATE_USER_CHALLENGE_ERROR,
    UPDATE_USER_CHALLENGE_REQUEST,
    UPDATE_USER_CHALLENGE_SUCCESS
} from "../actions/challenge-actions";
import {SET_NEW_USER_ACHIEVEMENTS_COUNT} from "../actions/achievement-actions";
import {NEED_UPDATE_USER_INFO} from "../actions/user-actions";

function* getChallenges() {

    yield put({ type: GET_CHALLENGES_REQUEST })

    const response = yield call(challengeApi.getChallenges)

    if(response.status === 200) {
        yield put({ type: GET_CHALLENGES_SUCCESS, payload: response.data })
        yield put({ type: SET_NEW_USER_ACHIEVEMENTS_COUNT, payload: response.data.newUserAchievementsCount })
    } else if (response.status === 404) {
        yield put({ type: GET_CHALLENGES_SUCCESS, payload: null })
    } else {
        yield put({ type: GET_CHALLENGES_ERROR, payload: response.status })
    }
}

function* getUserChallenges({ payload }) {

    yield put({ type: GET_USER_CHALLENGES_REQUEST })

    const response = yield call(challengeApi.getUserChallenges, payload)

    if(response.status === 200) {
        yield put({ type: GET_USER_CHALLENGES_SUCCESS, payload: response.data })
    } else if (response.status === 404) {
        yield put({ type: GET_USER_CHALLENGES_SUCCESS, payload: null })
    } else {
        yield put({ type: GET_USER_CHALLENGES_ERROR, payload: response.status })
    }

}

function* startChallenge({ payload }) {

    yield put({ type: START_CHALLENGE_REQUEST })

    const response = yield call(challengeApi.startChallenge, payload)

    if(response.status === 200) {
        yield put({ type: START_CHALLENGE_SUCCESS, payload: response.data })
        yield put({ type: NEED_UPDATE_USER_INFO, payload: true })
    } else {
        yield put({ type: START_CHALLENGE_ERROR, payload: response.status })
    }

}

function* sendChallengeAction({ payload }) {

    yield put({ type: SEND_CHALLENGE_ACTION_REQUEST })

    const response = yield call(challengeApi.sendChallengeAction, payload)

    if(response.status === 200) {
        yield put({ type: SEND_CHALLENGE_ACTION_SUCCESS, payload: response.data })
        if(payload.actionCode === 'REDEEM_OWNER_REWARD' && payload.actionCodeType === 'TOP_UP') {
            yield put({ type: NEED_UPDATE_USER_INFO, payload: true })
        }
    } else {
        yield put({ type: SEND_CHALLENGE_ACTION_ERROR, payload: {message: response.data, code: response.status} })
    }

}

function* updateUserChallenge({ payload }) {

    yield put({ type: UPDATE_USER_CHALLENGE_REQUEST })

    const response = yield call(challengeApi.updateUserChallenge, payload)

    if(response.status === 200) {
        yield put({ type: UPDATE_USER_CHALLENGE_SUCCESS, payload: response.data })
    } else {
        yield put({ type: UPDATE_USER_CHALLENGE_ERROR, payload: {message: response.data, code: response.status} })
    }

}

export default function* challengeSaga() {
    yield takeLatest(GET_CHALLENGES, getChallenges)
    yield takeLatest(GET_USER_CHALLENGES, getUserChallenges)
    yield takeLatest(START_CHALLENGE, startChallenge)
    yield takeLatest(SEND_CHALLENGE_ACTION, sendChallengeAction)
    yield takeLatest(UPDATE_USER_CHALLENGE, updateUserChallenge)
}
